import axios from "axios";

const trimTrailingSlash = (value = "") => String(value).replace(/\/+$/, "");

const normalizeApiUrl = (value = "") => {
  const clean = trimTrailingSlash(value);
  if (!clean) return "";
  return /\/api$/i.test(clean) ? clean : `${clean}/api`;
};

const normalizeSocketUrl = (value = "") => trimTrailingSlash(value).replace(/\/api$/i, "");

const rawApiUrl = process.env.REACT_APP_API_URL || "";
const rawSocketUrl = process.env.REACT_APP_SOCKET_URL || rawApiUrl;

export const API_URL = normalizeApiUrl(rawApiUrl);
export const SOCKET_URL = normalizeSocketUrl(rawSocketUrl);
export const API_BASE_URL = normalizeSocketUrl(API_URL);

const RETRY_FLAG = "__wavvyRetryAttempted";

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const createApiClient = (token = "") => {
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const client = axios.create({
    baseURL: API_URL,
    headers,
    timeout: 20000
  });

  client.interceptors.response.use(
    (response) => response,
    async (error) => {
      const config = error?.config;
      const hasResponse = Boolean(error?.response);
      const canRetry = config && !config[RETRY_FLAG] && !hasResponse;
      const online = typeof navigator === "undefined" ? true : navigator.onLine !== false;

      if (!canRetry || !online) {
        return Promise.reject(error);
      }

      config[RETRY_FLAG] = true;
      await sleep(450);
      return client(config);
    }
  );

  return client;
};
